import { Controller } from "@hotwired/stimulus"

// Brings a form's error summary into view and focuses it after a failed
// submission.
//
// The wholesale form sits at the bottom of a long marketing page. Its errors
// render at the top of the form, which can be a screenful or two above where
// the applicant was sitting when they hit submit — so without this the page
// appears to have done nothing at all.
//
// Usage: data-controller="form-error-summary"
// The element should carry tabindex="-1" so it can take focus.
export default class extends Controller {
  static values = {
    block: { type: String, default: "center" }
  }

  connect() {
    // Deferred a frame: Stimulus connects this element while Turbo is still
    // swapping the frame's children, so a scroll issued during connect() would
    // be computed against a half-finished layout.
    requestAnimationFrame(() => this.reveal())
  }

  reveal() {
    // The frame swap may have replaced this element before the frame arrived.
    if (!this.element.isConnected) return

    // Instant, not smooth. `behavior: "smooth"` silently does nothing on these
    // pages: body.landing-page sets `overflow-x: hidden`, which computes to
    // `overflow-y: auto` and makes body its own scroll container, and Chrome's
    // smooth path then no-ops instead of scrolling the document. Verified in
    // the browser — an instant scroll from the same position lands correctly
    // where a smooth one does not move at all.
    //
    // It also means there is no motion to suppress for reduced-motion users.
    this.element.scrollIntoView({ block: this.blockValue })

    // preventScroll because scrollIntoView above already placed it; letting
    // focus scroll as well can land the summary under the fixed navbar.
    this.element.focus({ preventScroll: true })
  }
}
